import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description: (
      <>
        Click Continue and connect your Texas Rangers account using our secure{" "}
        <Link target="_blank" href="https://www.MLB.com/">
          MLB.com
        </Link>{" "}
        login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Texas Rangers account. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "When will I receive my tickets?",
    description:
      "If your reservation is accepted, a Texas Rangers representative will be in contact with further information, including ticket delivery details.",
  },
  {
    title: "Is re-entry allowed?",
    description:
      "Re-entry is allowed only at specific gate locations. Before exiting the stadium, please confirm which gates allow re-entry with a Texas Rangers guest services representative.",
  },
  {
    title: "What is included in my suite?",
    description:
      "If your reservation is accepted, a Texas Rangers representative will be in contact with further information, including details regarding parking and food and beverage options.",
  },
];

export function TexasRangersCheckoutTerms() {
  return (
    <>
      In connection with your reservation, you will receive ticket-related
      commercial emails from{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="http://texasrangers.com/"
      >
        texasrangers.com
      </Link>
      . You may unsubscribe at any time. By checking this box you agree to
      receive additional commercial emails from{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="http://texasrangers.com/"
      >
        texasrangers.com
      </Link>{" "}
      and{" "}
      <Link
        target="_blank"
        href="http://MLB.com"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
      >
        MLB.com | The Official Site of Major League Baseball
      </Link>
      . The terms and conditions of your ticket and policies applicable to its
      use are available online at{" "}
      <Link
        target="_blank"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://www.mlb.com/rangers/tickets/terms-and-conditions"
      >
        Rangers Ticket Terms and Conditions | Texas Rangers
      </Link>
      . By clicking the Purchase Tickets button, you agree to accept all Terms
      and Conditions. Your purchase is not complete until a Texas Rangers
      representative connects with you to complete your purchase. Upon
      completing your purchase, you acknowledge and agree that your credit card
      will be charged. By clicking &apos;Purchase Tickets&apos;, you agree to
      the MLB Privacy Policy, Terms of Use and to receive your ticket(s) via an
      SMS text message to the mobile # associated with your Texas Rangers
      account. Message and data rates may apply. Tickets will be made available
      in the MLB Ballpark mobile application only.{" "}
      <Link
        target="_blank"
        href="http://MLB.com"
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
      >
        MLB.com | The Official Site of Major League Baseball
      </Link>{" "}
      and supported mobile device required.
    </>
  );
}

export function TexasRangersAdditionalDetailsDisclaimerTC() {
  return (
    <>
      By entering my name, checking the box above and clicking Submit Request, I
      hereby (i) agree to the{" "}
      <Link
        target="_blank"
        href="https://www.mlb.com/rangers/tickets/terms-and-conditions"
      >
        Terms of Use
      </Link>{" "}
      (ii) agree that my reservation will not be complete unless and until I
      receive a notice from the Texas Rangers confirming whether or not my
      reservation has been accepted in accordance with our agreement.
    </>
  );
}
